export const GET_WEBSITE = "GET_WEBSITE";
export const GET_WEBSITE_SUCCESS = "GET_WEBSITE_SUCCESS";
export const GET_WEBSITE_FAIL = "GET_WEBSITE_FAIL";

export const ADD_WEBSITE_SUCCESS = "ADD_WEBSITE_SUCCESS";
export const ADD_WEBSITE_FAIL = "ADD_WEBSITE_FAIL";
export const UPDATE_WEBSITE_SUCCESS = "UPDATE_WEBSITE_SUCCESS";
export const DELETE_WEBSITE_SUCCESS = "DELETE_WEBSITE_SUCCESS";
